'use client'

import React, { createContext, useContext, useState } from 'react'

interface RegistrationUserData {
  firstname?: string
  lastname?: string
  telephone?: string
  email?: string
}

interface RegistrationContextValue {
  userData: RegistrationUserData
  setUserData: (data: Partial<RegistrationUserData>) => void
  isEmailExistsModalOpen: boolean
  openEmailExistsModal: () => void
  closeEmailExistsModal: () => void
}

const RegistrationContext = createContext<RegistrationContextValue | null>(null)

export function RegistrationProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [userData, setUserDataState] = useState<RegistrationUserData>({})
  const [isEmailExistsModalOpen, setIsEmailExistsModalOpen] = useState(false)

  const setUserData = (data: Partial<RegistrationUserData>) => {
    setUserDataState((prev) => ({ ...prev, ...data }))
  }

  return (
    <RegistrationContext.Provider
      value={{
        userData,
        setUserData,
        isEmailExistsModalOpen,
        openEmailExistsModal: () => setIsEmailExistsModalOpen(true),
        closeEmailExistsModal: () => setIsEmailExistsModalOpen(false)
      }}
    >
      {children}
    </RegistrationContext.Provider>
  )
}

export function useUserData() {
  const ctx = useContext(RegistrationContext)
  if (!ctx)
    throw new Error(
      'useRegistration must be used within a RegistrationProvider'
    )
  return ctx
}
